(() => {
  if (window.__crFitHeadingLoaded) return;
  window.__crFitHeadingLoaded = true;

  const SELECTOR = '[data-cr-fit-heading]';
  const MIN_PX = 14;
  const observed = new WeakSet();
  const lastWidth = new WeakMap();

  /**
   * @param {Element} el
   */
  function fit(el) {
    if (!(el instanceof HTMLElement)) return;

    el.style.fontSize = '';

    const maxPx = parseFloat(getComputedStyle(el).fontSize);
    const width = el.clientWidth;
    if (!maxPx || !width) return;

    const needed = el.scrollWidth;
    if (needed <= width + 0.5) return;

    const next = Math.max(MIN_PX, ((maxPx * width) / needed) * 0.99);
    el.style.fontSize = `${next}px`;
  }

  /**
   * @param {ParentNode} [root]
   */
  function fitAll(root) {
    const scope = root && 'querySelectorAll' in root ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(fit);
  }

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const width = Math.round(entry.contentRect.width);
      const prev = lastWidth.get(entry.target);
      if (prev === width) continue;
      lastWidth.set(entry.target, width);
      fit(entry.target);
    }
  });

  /**
   * @param {ParentNode} [root]
   */
  function scan(root) {
    const scope = root && 'querySelectorAll' in root ? root : document;
    scope.querySelectorAll(SELECTOR).forEach((el) => {
      if (!observed.has(el)) {
        observed.add(el);
        resizeObserver.observe(el);
      }
      fit(el);
    });
  }

  function init() {
    scan(document);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => fitAll(document));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    scan(document);
  });
})();
